import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ONBOARDING_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
  communityId: string
  attachmentId: string
}

const mutateCommitBulkUploadProperty = async ({ data, communityId, attachmentId }: mutateProps) => {
  return await axiosAuth.post(`${ONBOARDING_API(communityId)}/properties/${attachmentId}/commit`, data);
};

const useCommitBulkUploadPropertyMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateCommitBulkUploadProperty,
    ...queryParams,
  });

export default useCommitBulkUploadPropertyMutation;
